import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['filterForm', 'taxonCounter', 'checkbox', 'sortInput', 'allFiltersCount', 'clearAll']

  initialize() {
    this.checkAppliedFilters()
    this.updateCountAllFilters()
    this.toggleClearAll()
  }

  checkAppliedFilters() {
    const query = window.location.search

    if(query) {
      const decodedURI = decodeURI(query)
      const urlParams = new URLSearchParams(decodedURI)
      const checkboxes = this.checkboxTargets

      checkboxes.forEach((checkbox)=>{
        for(const [key, value] of urlParams.entries()) {
          if(key.match(/search/) && checkbox.value == value) {
            checkbox.checked = true
            this.updateCount(checkbox)
          }
        }
      })
    }
  }

  updateCountAllFilters(){
    let checkedCount = this.checkboxTargets.filter((checkbox)=> checkbox.checked).length
    this.allFiltersCountTarget.innerText = checkedCount > 0 ? `(${checkedCount})`:''
    this.data.set('filtersCount', checkedCount)

    if (checkedCount > 0 ) {
      $(this.allFiltersCountTarget).parent().addClass('has-filters')
    }
  }

  updateCounter(event) {
    this.updateCount(event.target)
  }

  toggleClearAll(){
    let filtersCount = this.data.get('filtersCount')
    if (filtersCount > 0) {
      $(this.clearAllTarget).show()
    }else{
      $(this.clearAllTarget).hide()
    }
  }

  updateCount(checkbox) {
    const difference = checkbox.checked ? 1 : -1
    const counter = this.getMatchingCounter(checkbox.dataset.category)

    const count = (parseInt(counter.innerText.match(/\d/)) || 0) + difference
    const text = count == 0 ? "" : `(${count})`

    $(counter).parent().addClass('has-filters')

    counter.innerText = text
  }

  clearAll(ev) {
    ev.preventDefault()

    this.checkboxTargets.forEach(element => {
      element.checked = false
    });
    this.taxonCounterTargets.forEach(element => {
      this.getNumberSpan(element).innerText = ""
    });

    $(ev.target).hide()
    this.filterFormTarget.submit()
  }

  changeOrder(ev) {
    ev.preventDefault()

    const scope = ev.target.id
    this.sortInputTarget.value = scope
    this.filterFormTarget.submit()
  }

  getMatchingCounter(category) {
    const counter = this.taxonCounterTargets.find((element) => element.dataset.category == category)
    return this.getNumberSpan(counter)
  }

  getNumberSpan(counter) {
    return counter.childNodes[1]
  }
}
